export const smoothScrollTo = (targetY, duration = 500) => {
  const startY = window.scrollY;
  const diff = targetY - startY;
  let start;

  function step(timestamp) {
    if (!start) start = timestamp;
    const elapsed = timestamp - start;
    const progress = Math.min(elapsed / duration, 1);
    // Ease in-out cubic
    const ease = progress < 0.5 
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;

    window.scrollTo(0, startY + diff * ease);

    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

// Helper function to get the value of a CSS length variable in pixels.
// The browser resolves it on a hidden probe, so rem, calc() and nested var() all work.
// (Parsing the string returned NaN for calc() values like --navigationYOffset, which sent every
// anchor link and the multi-step form's Next button to the top of the page.)
export const getCSSVariableValue = (varName) => {
  const probe = document.createElement('div');
  probe.style.cssText = `position: absolute; visibility: hidden; pointer-events: none; width: 0; height: var(${varName}, 0px);`;
  document.body.appendChild(probe);
  const px = probe.getBoundingClientRect().height;
  probe.remove();
  return px;
}
